// src/context/ThemeContext.js
import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState('theme--bright');

    useEffect(() => {
        const savedTheme = localStorage.getItem('theme') || 'theme--bright';
        setTheme(savedTheme);
        document.body.className = savedTheme; // This line applies the class to the body
    }, []);

    const toggleTheme = () => {
        const newTheme = theme === 'theme--bright' ? 'theme--dark' : 'theme--bright';
        setTheme(newTheme);
        document.body.className = newTheme; // This toggles the class between 'light' and 'dark'
        localStorage.setItem('theme', newTheme);
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
